// extracted by mini-css-extract-plugin
export default {"walletExchange":"walletExchange_walletExchange__lmgRS","title":"walletExchange_title__Q9KPw"};